import React from 'react'
import cx from 'classnames'
import fallbackLogo from '../../pbs-logo.svg'
import { useAppSelector } from '../../hooks/useStore'

import type { LogoHeaderProps } from './types'

import type { RootState } from '../../reducers/types/reducerTypes'

const selectCobrandLogo = (state: RootState) =>
  state?.station?.white_cobranded_logo
const selectAlt = (state: RootState) => state?.station?.station_title

const LogoHeaderTS = ({ className = '' }: LogoHeaderProps) => {
  const cobrandLogo = useAppSelector(selectCobrandLogo)
  const alt = useAppSelector(selectAlt)

  return (
    <div className={cx('logo-header-ts', className)}>
      <img
        className="logo-header-ts__station-logo"
        src={cobrandLogo ? cobrandLogo : fallbackLogo}
        alt={`${alt} logo`}
      />
    </div>
  )
}

export default LogoHeaderTS
